"use client"

import type { ReactNode } from "react"
import { usePathname } from "next/navigation"
import CursorFollower from "@/components/cursor-follower"
import { SmoothScrollProvider } from "@/components/smooth-scroll-provider"

interface RuntimeEffectsProps {
  children: ReactNode
}

export function RuntimeEffects({ children }: RuntimeEffectsProps) {
  const pathname = usePathname()
  // v1 chrome (cursor follower + global smooth scroll) applies ONLY to legacy
  // v1 routes. v3 surfaces run their own Lenis and ban cursor-follow outright
  // (design do-not list, V3-MASTER-SPEC §3.4). Never run both scroll systems.
  const v1Mode = pathname?.startsWith("/v1-archive") || pathname?.startsWith("/work")

  if (!v1Mode) {
    return <>{children}</>
  }

  return (
    <SmoothScrollProvider>
      <CursorFollower />
      {children}
    </SmoothScrollProvider>
  )
}
